import {
  Button,
  Modal,
  Form,
  Input,
  Flex,
  Typography,
  message,
  Select,
  Spin,
  Table,
  Divider,
  Tag,
} from "antd";
import React, { forwardRef, useState, useImperativeHandle } from "react";
import { EditOutlined, BankOutlined, TableOutlined,SearchOutlined,CopyOutlined, WarningOutlined,} from "@ant-design/icons";
import http from "@/utils/http";
import api from "@/utils/api";
import commonFn from "@/utils/commonFn";
function useLazySelect(apiUrl, key, mapper, enableCache = true) {
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loaded, setLoaded] = useState(false);

  const load = async () => {
    if (loaded && enableCache) return;

    setLoading(true);
    try {
      const res = await http.get(apiUrl);
      const list = res?.data?.[key] || res?.data || [];
      setOptions(mapper(list));
      setLoaded(true);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  return { options, loading, load };
}

const EditModal = forwardRef((props, ref) => {
  const { onSuccess } = props;

  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [visible, setVisible] = useState(false);
  const [detailLoading, setDetailLoading] = useState(false);
  const [ownerId, setOwnerId] = useState(null);
const [longMsg, setLongMsg] = useState({ open: false, text: "", items: [] });
const [keyword, setKeyword] = useState("");
  // 存储接口返回的完整数据用于展示表格
  const [ownerData, setOwnerData] = useState(null);

// 解析msg
const parseListMsg = (msg) => {
  const m = String(msg || "").match(/^([\s\S]*?)\[([\s\S]*)\]\s*$/);
  if (!m) return null;
  const items = m[2].split(",").map((s) => s.trim()).filter(Boolean);
  return { text: m[1].replace(/[:：\s]+$/, ""), items };
};

const showError = (msg) => {
  const parsed = parseListMsg(msg);
  setLongMsg({
    open: true,
    ...(parsed && parsed.items.length > 0
      ? parsed
      : { text: msg || "Failed", items: [] }),
  });
};

  const stateSelect = useLazySelect(api.getStateDictList, "state", (data) =>
    Object.entries(data || {}).map(([key, label]) => ({
      label,
      value: key,
    })),
  );
  useImperativeHandle(ref, () => ({
    open: async (record) => {
      form.resetFields();
      setOwnerId(record.ownerId);
      setOwnerData(null);
      setVisible(true);

      await stateSelect.load();
      await loadOwnerDetail(record.ownerId);
    },
  }));

  const loadOwnerDetail = async (id) => {
    setDetailLoading(true);
    try {
      const res = await http.get(`${api.getOwnerById}?ownerId=${id}`);

      if (res?.code === "1" && res?.data) {
        form.setFieldsValue(res.data);
        setOwnerData(res.data); // 保存完整数据用于展示表格
      } else {
        message.error(res?.msg || "Failed to load data");
      }
    } catch (err) {
      message.error("Load owner detail failed");
    } finally {
      setDetailLoading(false);
    }
  };

  const onFinish = async (values) => {
    setLoading(true);

    const params = {
      ownerId,
      ...values,
    };

    try {
      const res = await http.post(api.getOwnerEdit, params);

      if (res?.code === "1") {
        message.success("Owner Updated Successfully");
        setVisible(false);
        form.resetFields();
        setOwnerData(null);
        onSuccess && onSuccess();
      } else {
      showError(res?.msg || "Update failed");
      }
    } catch (err) {
      console.error(err);
      message.error("Request failed, please try again");
    } finally {
      setLoading(false);
    }
  };

  // Entities 表格列配置
  const entityColumns = [
    {
      title: "Entity Code",
      dataIndex: "entityCode",
      key: "entityCode",
      align: "center",
    },
    {
      title: "Entity Name",
      dataIndex: "entityName",
      key: "entityName",
      align: "center",
      width:300,
    },
    {
      title: "# of Prop",
      dataIndex: "propertyCount",
      key: "propertyCount",
      align: "center",
    },
    {
      title: "GL Chart",
      dataIndex: "glChart",
      key: "glChart",
      align: "center",
    },
    // {
    //   title: "Entity Status",
    //   dataIndex: "entityStatusLabel",
    //   key: "entityStatusLabel",
    //   align: "center",
    // },
  ];

  // Bank Accounts 表格列配置
  const bankColumns = [
    {
      title: "Entity Name",
      dataIndex: "entityName",
      key: "entityName",
      align: "center",
      ellipsis: true,
    },
    {
      title: "Bank Account",
      dataIndex: "bankAccount",
      key: "bankAccount",
      align: "center",
    },
    {
      title: "Bank Name",
      dataIndex: "bankName",
      key: "bankName",
      align: "center",
      ellipsis: true,
    },
    {
      title: "Cash GL",
      dataIndex: "cashGl",
      key: "cashGl",
      align: "center",
    },
    {
      title: "PPM Bank#",
      dataIndex: "ppmBankNumber",
      key: "ppmBankNumber",
      align: "center",
      width:100,
    },
      {
      title: "Account Remark",
      dataIndex: "accountRemark",
      key: "accountRemark",
      align: "center",
    },
    // {
    //   title: "Bank Status",
    //   dataIndex: "activeLabel",
    //   key: "activeLabel",
    //   align: "center",
    // },
  ];

  return (
    <>
    <Modal
      title={
        <Flex justify="flex-start" align="flex-start" className="model_title">
          <EditOutlined className="model_title_mr10" />
          <Typography.Title level={4} className="mg">
            EDIT OWNER
          </Typography.Title>
        </Flex>
      }
      width="90%"
      centered
      open={visible}
      maskClosable={false}
      onCancel={() => {
        setVisible(false);
        form.resetFields();
        setOwnerData(null);
      }}
      footer={
        <div style={{ display: "flex", justifyContent: "center", gap: "16px" }}>
          <Button
            key="back"
            onClick={() => {
              setVisible(false);
              form.resetFields();
              setOwnerData(null);
            }}
          >
            Cancel
          </Button>
          <Button
            key="submit"
            type="primary"
            loading={loading}
            onClick={() => form.submit()}
          >
            Submit
          </Button>
        </div>
      }
    >
      <Spin spinning={detailLoading}>
        <div className="model_top">
          <div className="model_content">
<Flex gap={16} style={{ width: "100%" }} align="flex-start">
  {/* 第 1 列：表单 */}
  <div
    style={{
     flex: "0 0 20%",
      minWidth: 300,
      maxHeight: "calc(100vh - 300px)",
      overflowY: "auto",
    }}
  >
    <Form
      form={form}
      name="editOwnerForm"
      layout="horizontal"
      labelCol={{ style: { width: "150px" } }}
      wrapperCol={{ style: { flex: 1 } }}
      onFinish={onFinish}
      className="compact-form"
    >
                  <Form.Item
                    name="ownerCode"
                    label="Owner Code"
                    rules={[{ required: true }]}
                  >
                    <Input placeholder="Owner Code" />
                  </Form.Item>

                  <Form.Item
                    name="firstName"
                    label="First Name"
                    rules={[{ required: true }]}
                  >
                    <Input placeholder="First Name" />
                  </Form.Item>

                  <Form.Item name="middleName" label="Middle Name">
                    <Input placeholder="Middle Name" />
                  </Form.Item>

                  <Form.Item
                    name="lastName"
                    label="Last Name"
                    rules={[{ required: true }]}
                  >
                    <Input placeholder="Last Name" />
                  </Form.Item>

                  <Form.Item
                    name="street"
                    label="Mailing Address"
                    rules={[{ required: true }]}
                  >
                    <Input placeholder="Street" />
                  </Form.Item>

                  <Form.Item
                    name="city"
                    label="City"
                    rules={[{ required: true }]}
                  >
                    <Input placeholder="City" />
                  </Form.Item>

                  <Form.Item
                    name="state"
                    label="State"
                    rules={[{ required: true }]}
                  >
                    <Select
                      placeholder="Select State"
                      loading={stateSelect.loading}
                      options={stateSelect.options}
                      showSearch
                      optionFilterProp="label"
                    />
                  </Form.Item>

                  <Form.Item
                    name="zip"
                    label="Zip"
                    rules={[
                      { required: true, message: "Zip is required!" },
                      { validator: commonFn.zipValidator },
                    ]}
                  >
                    <Input placeholder="Zip" />
                  </Form.Item>

                  <Form.Item
                    name="phone"
                    label="Phone"
                    rules={[{ validator: commonFn.usPhoneValidator }]}
                  >
                    <Input placeholder="Phone" />
                  </Form.Item>

                  <Form.Item name="email" label="Email">
                    <Input placeholder="Email" />
                  </Form.Item>

                  <Form.Item name="status" label="Status">
                    <Select
                      placeholder="Select Status"
                      options={[
                        { label: "Active", value: 1 },
                        { label: "Inactive", value: 0 },
                      ]}
                      allowClear
                    />
                  </Form.Item>
                </Form>
              </div>
         
  {/* 第 2 列：Entities */}
  {/* <div style={{ flex: 1, minWidth: 0 }}> */}
  <div style={{ flex: "0 0 30%", minWidth: 0 }}>
    {ownerData && (
      <>
        <div
          style={{
            fontWeight: 600,
            fontSize: "16px",
            marginBottom: 12,
            color: "#1E293B",
          }}
        >
          <TableOutlined style={{ marginRight: 8 }} />
          Total Entities: {ownerData.totalEntities || 0}
        </div>
        <Table
          rowClassName="table-row-gradient"
          columns={entityColumns}
          dataSource={ownerData.entities || []}
          pagination={false}
          size="small"
          bordered
          scroll={{ x: "max-content", y: "calc(100vh - 380px)" }}
          rowKey="trustId"
        />
      </>
    )}
  </div>

    <div style={{ flex: 1, minWidth: 0 }}>
    {ownerData && (
      <>
        <div
          style={{
            fontWeight: 600,
            fontSize: "16px",
            marginBottom: 12,
            color: "#1E293B",
          }}
        >
          <BankOutlined style={{ marginRight: 8 }} />
          Total Bank Accounts: {ownerData.totalBankAccounts || 0}
        </div>
        <Table
          rowClassName="table-row-gradient"
          columns={bankColumns}
          dataSource={ownerData.bankAccounts || []}
          pagination={false}
          size="small"
          bordered
          scroll={{ x: "max-content", y: "calc(100vh - 380px)" }}
          rowKey="bankId"
        />
      </>
    )}
  </div>


            </Flex>
          </div>
        </div>
      </Spin>
    </Modal>

<Modal
  open={longMsg.open}
  width={640}
  maskClosable={false}
  title={
    <span>
      <WarningOutlined style={{ color: "#faad14", marginRight: 8 }} />
      Cannot Proceed
    </span>
  }
  onCancel={() => setLongMsg((p) => ({ ...p, open: false }))}
  afterClose={() => setKeyword("")}
  footer={
    <div style={{ display: "flex", justifyContent: "center", gap: 16 }}>
      {longMsg.items.length > 0 && (
        <Button
          icon={<CopyOutlined />}
          onClick={() =>
            navigator.clipboard
              .writeText(longMsg.items.join(", "))
              .then(() => message.success("Copied"))
              .catch(() => message.error("Copy failed"))
          }
        >
          Copy all
        </Button>
      )}
      <Button
        type="primary"
        onClick={() => setLongMsg((p) => ({ ...p, open: false }))}
      >
        OK
      </Button>
    </div>
  }
>
  <Typography.Paragraph>
    {longMsg.text}
    {longMsg.items.length > 0 && (
      <>
        {" "}
        <Typography.Text strong>({longMsg.items.length})</Typography.Text>
      </>
    )}
  </Typography.Paragraph>

  {longMsg.items.length > 0 && (
    <>
      <Input
        allowClear
        prefix={<SearchOutlined style={{ color: "#bfbfbf" }} />}
        placeholder="Search..."
        value={keyword}
        onChange={(e) => setKeyword(e.target.value)}
        style={{ marginBottom: 12 }}
      />

      <div
        style={{
          maxHeight: 320,
          overflowY: "auto",
          padding: 8,
          background: "#fafafa",
          borderRadius: 6,
        }}
      >
        {(() => {
          const list = keyword
            ? longMsg.items.filter((i) =>
                i.toLowerCase().includes(keyword.toLowerCase()),
              )
            : longMsg.items;
          return list.length ? (
            list.map((i) => (
              <Tag key={i} style={{ margin: 4 }}>
                {i}
              </Tag>
            ))
          ) : (
            <Typography.Text type="secondary">No match</Typography.Text>
          );
        })()}
      </div>
    </>
  )}
</Modal>
    </>
  );
});

export default EditModal;
